import React from "react";
import EiaCard from "./EiaCard";
import {Badge, Divider, Flex, Heading, Text, View} from "@aws-amplify/ui-react";
import OnlineAvailabilityButton from "../buttons/OnlineAvailabilityButton";

const littleCardBackground = "#ffffff0d"
const bigCardBackground = "hsl(0, 0%, 20%)"



const UserCard = function (props) {
    const {user, title} = props;

    const rows = [
        [<Badge>{"Nickname"}</Badge>, <Text><Flex>{user.name}{user.countryCode ? <img alt={"Country"} src={require("../../resources/flags/" + user.countryCode + ".svg")}
                                                                                      style={{width: 30}}/> : null}</Flex></Text>],
        [<Badge>{"Battle Tag"}</Badge>, <Text>{user.battleTag}</Text>],
        [<Badge>{"Discord Name"}</Badge>, <Text>{user.discordName}</Text>],
    ];

    return <EiaCard roundCorners={true} styleBgColor={bigCardBackground}>
        <EiaCard roundCorners={true} styleBgColor={bigCardBackground}>
            <Heading level={4}> <OnlineAvailabilityButton user={user} /> {title}</Heading>
            <Divider/>
        </EiaCard>
        <EiaCard styleBgColor={bigCardBackground}>
            <Flex direction="column" gap="0.5rem">
                {rows.map(([column1, column2], index) => (
                    <Flex key={index} direction="row" alignItems="baseline">
                        <View width="8rem">
                            {column1}
                        </View>
                        {column2}
                    </Flex>
                ))}
            </Flex>
        </EiaCard>
    </EiaCard>
}

export default UserCard;